module.exports = __webpack_public_path__ + "static/media/Floor-1.7096fb77.png";